import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { SummaryCounts } from '../api/types';

// Live tab-badge counts (No show / Missing timesheet / Needs approval).
// Kept lightly fresh so badges reflect queue changes without a manual reload.
const useDashboardSummary = (agencyId: number) =>
  useQuery<SummaryCounts>({
    queryKey: dashboardV2QueryKeys.summary(agencyId),
    queryFn: () => dashboardV2Client.getSummary(agencyId),
    enabled: agencyId != null,
    staleTime: 30_000,
  });

export default useDashboardSummary;
